import { useTranslation } from 'react-i18next'

import i18n from './index'

export function useCommonTranslation() {
  return useTranslation(undefined, { i18n })
}
